import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import './css/lp_logo.css';
import App from './components/App';
import reportWebVitals from './components/reportWebVitals';
import init, { 
  draw_spaceship,
  draw_triangle, 
  draw_to_the_canvas,
  greet, 
  greet_smiley 
} from './pkg/lp_extended2.js';


const root = ReactDOM.createRoot(document.getElementById('root'));

init().then(() => root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();